import * as requestFromServer from "./SectionsCrud";
import { callTypes, sectionSlice } from "./SectionsSlice";

const {actions} = sectionSlice;

export const getSections = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getSections(queryParams)
    .then(response => {
      dispatch(actions.sectionsFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getAllSections = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getAllSections(queryParams)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const getSection = id => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  
  if (!id) {
    return requestFromServer
    .getNewSection()
    .then(response => {
      dispatch(actions.sectionFetched(response.data));
    })
    .catch(error => {
      
    });
  }
  
  return requestFromServer
    .getSection(id)
    .then(response => {
      dispatch(actions.sectionFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const saveSection = section => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .saveSection(section)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });    
};

export const deleteSections = ids => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteSections(ids)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const cleanSectionsState = () => dispatch => {
  dispatch(actions.sectionsStateCleaned());
}